export const DOMAIN_API = 'https://api.eboxenterprises.com';
// export const DOMAIN_API = 'https://api.dev.eboxenterprises.com';
//
